import { i18n } from '@/locales';
import { weekTypeList } from './week';
const result = {};
export default (formatType) => {
    weekTypeList.forEach((code, index) => {
        result[code] = {
            text: i18n.t(`common.week_type_code.${formatType}_text[${index}]`),
            value: code,
        };
    });
    return result;
};
